/** Single source of truth for drawdown types (used as a type and a runtime allow-list). */
export const DRAWDOWN_TYPES = ["eod", "eot", "trailing", "static"] as const;
export type DrawdownType = (typeof DRAWDOWN_TYPES)[number];

export interface FirmVM {
  id: string;
  name: string;
  slug: string;
  logoS3Key: string | null;
  countryCode: string | null;
  foundedYear: number | null;
  rating: number | null;
  affiliateUrl: string | null;
  promoCode: string | null;
}

export interface OfferVM {
  id: string;
  firmId: string;
  planName: string;
  accountSizeK: number;
  accountType: "eval" | "direct";
  priceUsd: number;
  discountPercent: number | null;
  discountExpiresAt: string | null; // ISO string from server
  billingType: "one_time" | "monthly";
  activationFeeUsd: number;
  platforms: string[];
  drawdownUsd: number | null;
  drawdownType: DrawdownType | null;
  profitTargetUsd: number | null;
  dailyLossUsd: number | null;
  roundTripMicroUsd: number | null;
  roundTripMiniUsd: number | null;
  affiliateUrl: string | null;
}

export interface ComparatorData {
  firms: FirmVM[];
  offers: OfferVM[];
}

export type SortKey = "price" | "rating" | "size" | "firm" | "activation";
export type SortDir = "asc" | "desc";

export type DailyLossFilter = "all" | "none" | "defined";
export type RatingBand = "all" | "high" | "mid" | "low";

export interface ComparatorFilters {
  search: string;
  firmSlugs: string[];
  sizesK: number[];
  accountTypes: ("eval" | "direct")[];
  drawdownTypes: DrawdownType[];
  platforms: string[];
  dailyLoss: DailyLossFilter;
  ratingBand: RatingBand;
  maxPrice: number | null;
  sortKey: SortKey;
  sortDir: SortDir;
}
